import gql from "graphql-tag";
import { GraphPoint } from "../baseTypes";
export default gql`
  query GetGraph(
    $filter: SearchableTestFilterInput!
    $startDate: String!
    $endDate: String!
  ) {
    getGraph(filter: $filter, startDate: $startDate, endDate: $endDate) {
      data
      label
    }
  }
`;
export interface GetGraphQuery {
  getGraph: Array<GraphPoint> | null;
}
